<template>
  <div>
    <transition name="populate">
      <section v-if="tickets" class="program">
        <filters :options="filterOptions" :filter="filter"></filters>

        <div v-if="filteredTickets && !filteredTickets.length && tickets && tickets.length && !filtering" class="group-program">
          <h4>Für deine Auswahl haben wir leider keinen passenden Film im Programm. Einfach Auswahl ändern und nochmal probieren.</h4>
        </div>

        <div v-if="tickets && !tickets.length  && !filtering" class="group-program">
          <h4>Im Moment ist Spielpause auf der Seebühne, es werden keine Filme gezeigt.</h4>
        </div>

        <div class="group-program" v-for="(month, index) in filteredTickets" :key="index">
          <h4>{{ month.month }}</h4>
          <div class="movieContainer">
              <movie-cover v-for="ticket in month.items" :key="ticket.fd" theme="light" :mode="filter.view" :ticket="ticket" detailButton></movie-cover>
            <article></article>
            <article></article>
          </div>
        </div>
      </section>
    </transition>
    <section v-if="!tickets" class="program placeholder">
      <div class="group-program">
        <div class="movieContainer">
            <movie-cover v-for="i in 4" :key="i" theme="light" :mode="filter.view" :ticket="null" detailButton></movie-cover>
            <article></article>
            <article></article>
          </div>
      </div>
    </section>
  </div>
</template>

<script>

import 'swiper/dist/css/swiper.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import FavoriteIcon from '@/components/elements/FavoriteIcon.vue'
import MovieCover from '@/components/modules/Movie/MovieCover.vue'
import Filters from '@/components/modules/Program/Filters.vue'
import { filter, forEach, merge, map, uniq, pull, find } from 'lodash-es'

export default {
  components: { swiper, swiperSlide, FavoriteIcon, MovieCover, Filters },
  props: ['tickets', 'seasons'],
  data () {
    return {
      filtering: false,
      filter: {
        genre: null,
        occasion: null,
        period: null,
        season: null,
        month: null,
        view: ''
      },
      swiperOption: {
        spaceBetween: '4%',
        slidesPerView: 5,
        loop: false,
        loopedSlides: 5,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      }
    }
  },
  methods: {
    doFilter (filter) {
      var vm = this
      vm.filtering = true
      let temp = JSON.parse(JSON.stringify(this.filter))
      // This ugly hack is needed because using v-lazy on movies pictures, some picture don't get updated after reordering the movies.
      this.filter = Object.assign({}, temp, {genre: 'nonexistent'})
      setTimeout(function () {
        vm.filter = Object.assign({}, temp, filter)
        vm.filtering = false
      }, 250)
    },
    resetFilter (year) {
      this.filter = Object.assign({}, this.filter, {genre: null, occasion: null, month: null, season: year})
    },
    isFiltering () {
      return this.filter.occasion || this.filter.month
    }
  },
  computed: {
    filterOptions: function () {
      let options = {
        genre: [],
        occasion: [],
        period: [],
        months: [],
        seasons: this.seasons
      }
      forEach(this.tickets, function (month) {
        options.genre = merge(options.genre, map(month.items, 'movie.g'))
        options.occasion = merge(options.occasion, map(month.items, 'movie.o'))
        options.months = options.months.concat(month.month)
      })
      options.genre = uniq(pull(options.genre, null))
      options.occasion = uniq(pull(options.occasion, null))
      options.months = uniq(pull(options.months, null))

      if (this.seasons && this.seasons.length && !this.filter.season) {
        this.filter.season = this.seasons[0]
      }

      return options
    },
    filteredTickets: function () {
      var vm = this
      if (!this.tickets || !this.isFiltering()) {
        return this.tickets
      }
      var filteredTickets = {}
      forEach(this.tickets, function (item) { filteredTickets[item.month] = item })

      // if (this.filter.genre) {
      //   forEach(filteredTickets, function (month) {
      //     let items = filter(month.items, item => item.movie.g === vm.filter.genre)
      //     filteredTickets[month.month] = {month: month.month, monthValue: month.monthValue, items: items}
      //   })
      // }

      if (this.filter.occasion) {
        forEach(filteredTickets, function (month) {
          let items = filter(month.items, item => item.movie.o === vm.filter.occasion)
          filteredTickets[month.month] = {month: month.month, monthValue: month.monthValue, items: items}
        })
      }

      if (this.filter.month) {
        let monthInt = parseInt(find(filteredTickets, {month: this.filter.month}).monthValue)
        filteredTickets = filter(filteredTickets, month => parseInt(month.monthValue) === monthInt)
      }
      // Remove empty months
      filteredTickets = filter(filteredTickets, 'items.length')

      return Object.values(filteredTickets)
    }
  },
  mounted () {
    this.$event.$on('filter', this.doFilter)
    this.$event.$on('seasonChange', this.resetFilter)
    this.$event.$emit('MoviesDataMounted')
  }
}
</script>

<style lang="scss" scoped>
@import "@/sass/_variables.scss";

.program {
  padding:3em 0 3em 0;
  @include for-size(phone-only) {
    padding: 0 0 3em 0;
  }
  background-color:white;
  width:100%;
  position: relative;
  min-height: 20em;
  transform: translateY(0%);
  transition-property: transform, opacity;
  transition-duration: 0.8s, .5s;
  transition-delay: 0s;
  transition-timing-function: ease, ease;
  position: relative;

  .group-program{
    width: 100%;
    padding: 0 3em 0 3em;
    margin-top: 0;
    box-sizing: border-box;
    h4 {
      font-size: 2.5em;
      font-weight: 900;
      margin: 2% 0;
    }
  }
  .movieContainer{
    width: 100%;
    box-sizing: border-box;
    position: relative;

    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-between;

    $gap:4%;

    article {
      position: relative;
      width: calc(1/4*100% - (1 - 1/4) * #{$gap});
      @include for-size(phone-only) {
        width: calc(1/2*100% - (1 - 1/2) * #{$gap});
      }
      @include for-size(tablet-portrait-up) {
        width: calc(1/3*100% - (1 - 1/3) * #{$gap});
      }
      @include for-size(tablet-landscape-up) {
        width: calc(1/4*100% - (1 - 1/4) * #{$gap});
      }
    }
  }
}

.populate-enter {
  .program {
      transform: translateY(20%);
      opacity: 0;
  }
}

.transitionevent-leave-to, .transitionevent-leave {
  .program {
    transform: translateY(20vh);
    opacity: 0;
    transition-property: transform, opacity;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/modules/Program/MoviesData.vue